import {
  ADD_INVESTMENT,
  GET_USER_INVESTMENT,
  GET_ALL_INVESTMENT,
} from "../actions/action.types";

const initialState = {
  allInvestments: [],
  userInvestmentData: {},
};

const investmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_INVESTMENT:
      return {
        ...state,
        userInvestmentData: action.payload,
      };
    case GET_USER_INVESTMENT:
      return {
        ...state,
        userInvestmentData: action.payload,
      };
    case GET_ALL_INVESTMENT:
      return {
        ...state,
        allInvestments: action.payload,
      };
    default:
      return state;
  }
};

export default investmentReducer;
